import type { FilteredValue, Value } from '@fitogest/reactive-form-builder/interfaces';
import { Utils } from 'src/app/common/utils';
import type { TareasBioModel } from 'src/app/models/tareas/tareas-bio.model';
import { TratamientosControlValueResolver } from './tratamientos-control-value-resolver';

export type TratamientosControlProductOption = FilteredValue<TareasBioModel> & { tipo?: string };

/**
 * Builds the product option labels used by Tratamientos Control repeatable rows.
 */
export class TratamientosControlProductOptionMapper {
    public static mapOptions(options: TratamientosControlProductOption[]): TratamientosControlProductOption[] {
        return options
            .map((option) => TratamientosControlProductOptionMapper.mapOption(option))
            .filter((option) => option.label.trim() !== '');
    }

    public static mapRawItem(item: unknown): Value<unknown> {
        const rawProduct = item as TareasBioModel | null;
        const productRecord = rawProduct as Record<string, unknown> | null;
        const bioProduct = TratamientosControlValueResolver.getBioProductValue(rawProduct?.producto);
        const bioProductRecord = bioProduct as Record<string, unknown> | null;
        const baseOption: TratamientosControlProductOption = {
            label: String(bioProductRecord?.['materia_activa'] ?? productRecord?.['materia_activa'] ?? rawProduct?.nombre ?? ''),
            value: rawProduct,
            raw: rawProduct,
            ...(typeof rawProduct?.tipo_plaga === 'string' ? { tipo: rawProduct.tipo_plaga } : {}),
        };

        return TratamientosControlProductOptionMapper.mapOption(baseOption) as Value<unknown>;
    }

    private static mapOption(option: TratamientosControlProductOption): TratamientosControlProductOption {
        let level = '';
        let numreg = '';
        const product = TratamientosControlValueResolver.getBioProductValue(option.value?.producto);

        if (product) {
            level = Utils.checkIfProductIsValid(product.fecha_caducidad, option.tipo ?? '') + ' ';
            numreg = (product.referencia ?? '') + ' ';
        }

        if (option.label && option.value && option.label.indexOf(option.value.nombre ?? '') === -1) {
            return {
                ...option,
                label: level + option.label + ' (' + numreg + option.value.nombre + ')',
            };
        }

        return option;
    }
}
